import React, { useEffect, useState } from "react";
import requestApi from "../../apirest/index";
import { toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import NumberFormat from 'react-number-format';
import CostItemsTable, { UNIT_OPTIONS } from "./components/CostItemsTable";
import "./components/CostTabLayout.css";

const Logistics = ({ onLogisticsChange, productFinded, savedId }) => {
  const [logisticsCosts, setLogisticsCosts] = useState([{
    valor: 0,
    quantity: 1,
  }]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);



  const tipos = [
    "Caixa de Papelão",
    "Saco para guardar a Roupa",
    "Carta",
    "AntiLacre",
    "Corda (Tag)",
    "Etiqueta Interna Tamanho",
    "Etiqueta de Composição",
    "Tags com a Logo",
    "Tag conexao",
    "Papel de Seda",
    "Plastico",
    "Adesivo",
  ];


  useEffect(() => {
    const total = logisticsCosts.reduce((acc, item) => acc + item.totalAmount, 0);
    setTotalAmount(total);
  }, [logisticsCosts]);

  const findLogistics = async () => {

    setLoading(true);
    try {
      const res = await requestApi(`/logisticsCosts/`, {}, "get");
      const logisticsCosts = res?.data?.doc[0];
      setLoading(false);
      // Atualiza todos de uma vez
      if (logisticsCosts) {
        setId(logisticsCosts._id);
        setLogisticsCosts(logisticsCosts.logisticsCosts);
        setTotalAmount(logisticsCosts.totalAmount);
      } else {
        setLogisticsCosts([{
          valor: 0,
          quantity: 1,
        }]);
        setTotalAmount(0);
      }
    } catch (error) {
      console.log(error);
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });

      setLoading(false);
    }
  };

  useEffect((() => {
    findLogistics();
  }), [productFinded])

  // Sincroniza o id local com o id real recebido do pai após salvar, senão
  // o próximo save reporta id=null de novo e cria um registro duplicado.
  useEffect(() => {
    if (savedId) setId(savedId);
  }, [savedId]);

  useEffect(() => {
    // Notifica o componente pai sobre as mudanças
    if (onLogisticsChange) {
      onLogisticsChange({
        logisticsCosts,
        totalAmount,
        id
      });
    }
  }, [
    logisticsCosts
  ]);


  const update = (lista, novoValor, atributo, index) => {

    const listaAtualizados = lista.map((item, i) => {
      if (i === index) {
        const quantity = atributo === "quantity" ? novoValor : item.quantity;
        const amount = atributo === "amount" ? novoValor : item.amount;
        const totalAmount = quantity * amount;
        return { ...item, [atributo]: novoValor, totalAmount };
      }
      return item; // Retornar o objeto original se não for o índice correspondente
    });

    atualizarListas(listaAtualizados);
  };


  const add = async (lista) => {
    const novaLista = [
      ...lista,
      {
        valor: 0,
        description: "teste",
      },
    ];

    atualizarListas(novaLista);
  }

  const deleteObjeto = (lista, index) => {
    // Verifica se o índice é válido
    if (index < 0 || index >= lista.length) {
      console.error("Índice inválido");
      return;
    }

    // Cria uma cópia do array original
    const novaLista = [...lista];

    // Remove o objeto no índice especificado
    novaLista.splice(index, 1);

    atualizarListas(novaLista);
  };


  function atualizarListas(novos) {
    setLogisticsCosts(novos);
    const total = novos.reduce((acc, item) => acc + item.totalAmount, 0);
    setTotalAmount(total);
  }

  const logisticsColumns = [
    { key: "company", label: "Tipo", type: "select", options: tipos },
    { key: "unit", label: "Unidade", type: "select", options: UNIT_OPTIONS },
    { key: "quantity", label: "Quantidade", type: "number" },
    { key: "amount", label: "Valor Unitário", type: "currency" },
  ];

  const renderLogistics = () => {
    return <div className="cost-tab-page">
      <div className="cp-card cost-tab-card">
        <CostItemsTable
          title="Custos de Logística"
          items={logisticsCosts}
          columns={logisticsColumns}
          totalLabel="Total logística"
          totalValue={totalAmount}
          onAdd={() => add(logisticsCosts)}
          onUpdate={(index, key, value) => update(logisticsCosts, value, key, index)}
          onDelete={(index) => deleteObjeto(logisticsCosts, index)}
        />
      </div>

      <div className="cost-grand-total">
        <span>Total logística</span>
        <strong>
          <NumberFormat
            value={totalAmount}
            displayType="text"
            thousandSeparator="."
            prefix="R$"
            decimalScale={2}
            fixedDecimalScale={true}
            decimalSeparator=","
          />
        </strong>
      </div>

      {
        loading && <Loading overlay />
      }
    </div>;
  }



  return (
    <>
      {renderLogistics()}
    </>
  );


};

export default Logistics;


